import React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Box from "@mui/material/Box";
import { useMyGames, useAllRoyalties } from "@seabrookstudios/pitch2table";
import { formatNumber, useUserCurrencyFormatter } from "../games/royalties/currency-formatting";
import Grid from "@mui/material/Grid";
import { useRoyaltyUnits } from "@seabrookstudios/pitch2table-core";
import { Link } from "react-router-dom";
import { Path } from "../Path";

export const SummaryCard = () => {
  const { data: games = [] } = useMyGames();
  const { data: royalties = [] } = useAllRoyalties();
  const formatUserCurrency = useUserCurrencyFormatter();

  const nonArchivedGames = games.filter((game) => !game.archived);

  const pitching = nonArchivedGames.filter((game) => game.status === "PitchingNow").length;
  const signedGames = nonArchivedGames.filter((game) => game.status === "Signed").length;
  const publishedGames = nonArchivedGames.filter((game) => game.status === "Published").length;

  const totalRoyalties = royalties.reduce((total, royalty) => total + royalty.convertedAmount, 0);

  const totalUnits = useRoyaltyUnits(royalties);

  if (pitching === 0 && signedGames === 0 && publishedGames === 0 && totalRoyalties === 0 && totalUnits === 0) {
    return null;
  }

  const linkToPitching = new URLSearchParams(window.location.search);
  linkToPitching.set("games", "Pitching");

  const linkToDone = new URLSearchParams(window.location.search);
  linkToDone.set("games", "Done");

  const linkStyle = { textDecoration: "none", color: "inherit" };

  const summaryItems = [
    {
      key: "pitching",
      show: true,
      to: {
        pathname: Path.games().pathname,
        search: linkToPitching.toString(),
      },
      title: pitching,
      subheader: "Pitching",
    },
    {
      key: "signed",
      show: true,
      to: {
        pathname: Path.games().pathname,
        search: linkToDone.toString(),
      },
      title: signedGames,
      subheader: "Signed",
    },
    {
      key: "published",
      show: publishedGames > 0,
      to: {
        pathname: Path.games().pathname,
        search: linkToDone.toString(),
      },
      title: publishedGames,
      subheader: "Published",
    },
    {
      key: "royalties",
      show: totalRoyalties > 0,
      to: Path.royalties().none(),
      title: formatUserCurrency(totalRoyalties),
      subheader: "Royalties",
    },
    {
      key: "units",
      show: totalUnits > 0,
      to: Path.royalties().none(),
      title: formatNumber(totalUnits),
      subheader: "Units",
    },
  ].filter((item) => item.show);

  const smWidth = Math.max(12 / summaryItems.length + 1, 2);
  const mdWidth = Math.max(12 / summaryItems.length, 2);

  return (
    <Box>
      <Grid container spacing={2} alignItems="stretch">
        {summaryItems.map((item) => (
          <Grid key={item.key} size={{ xs: 6, sm: smWidth, md: mdWidth }}>
            <Card sx={{ height: "100%" }}>
              {item.to ? (
                <Link to={item.to} style={linkStyle}>
                  <CardHeader title={item.title} subheader={item.subheader} />
                </Link>
              ) : (
                <CardHeader title={item.title} subheader={item.subheader} />
              )}
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
